var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentationChart = function SvgPresentationChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M3.933 11.334h8.127c1.267 0 1.933-.667 1.933-1.933V1.334h-12v8.067c.007 1.266.674 1.933 1.94 1.933M1.333 1.334h13.334M5.333 14.667 8 13.334v-2M10.667 14.667 8 13.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m5 7.334 2.1-1.753c.167-.14.387-.1.5.086l.8 1.334c.113.186.333.22.5.086L11 5.334"
  })));
};
export default SvgPresentationChart;